import api from '@/apis/di/sysUserAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('sysUser', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sys_user',
    field: {
      key: 'user_id',
      code: 'role_name',
      name: 'full_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Xóa dữ liệu.
   * ncquyen 3.12.2022
   */
  async customDelete(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      res = await api.customDelete(payload);
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
